import type { FC } from "react";
import type { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { usePropertyValueMutation } from "web_myplann/Portfolio/Components/Redesign/Detail/Value/usePropertyValueMutation";
import { ValueDrawer } from "web_myplann/Portfolio/PortfolioShared/ValueDrawer";

const PageResources = Resources.PortfolioDetail.SharedLabels.ValueDrawer;

type Props = {
	open: boolean;
	onClose: () => void;
	propertyId: number;
	propertyType: ClientPropertyTypeEnum;
	valueLabel: string;
	value: number | null | undefined;
	currencySign: string;
};

export const PropertyValueDrawer: FC<Props> = ({
	open,
	onClose,
	propertyId,
	propertyType,
	valueLabel,
	value,
	currencySign,
}) => {
	const { t } = useResource();
	const { save, isPending } = usePropertyValueMutation(
		propertyId,
		propertyType,
	);

	return (
		<ValueDrawer
			open={open}
			onClose={onClose}
			title={t(
				value == null ? PageResources.fillTitle : PageResources.updateTitle,
			)}
			valueLabel={valueLabel}
			currencySign={currencySign}
			defaultValue={value}
			isPending={isPending}
			onSave={save}
		/>
	);
};
